var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-col',[_c('el-menu',{staticClass:"el-menu-vertical-demo",attrs:{"unique-opened":true,"router":true,"background-color":"transparent","text-color":"#444","default-active":_vm.logUrl,"collapse":_vm.isCollapse,"collapse-transition":false}},[_c('common-menu',{attrs:{"getMenu":_vm.getMenu,"isCollapse":_vm.isCollapse}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab8ca2fe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/SideList.vue
// module id = null
// module chunks = 